const ClubAdminRolesEnum = {
	AGENT: 'A',
	COURT_BOOKINGS: 'C',
	MATCHA: 'M',
	MEMBERSHIP_FEES: 'F',
	COMMUNCIATIONS: 'N',
	POINT_OF_SALE: 'P'
};

export default ClubAdminRolesEnum